module.exports = __webpack_public_path__ + "media/images/icons/outlined/bulb-6341c6c736262e9d41fe025388f3b7e2.svg";